// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/pikaday/scss/pikaday.scss
// module id = 767
// module chunks = 0